import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
	createPersistedState({
		key: 'dengl:persistedState',
		paths: ['forecastDestination', 'dntConsent']
	})(store);
};
